import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../../Environment/environment'
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BServiceService {
  baseurl:string="";
  constructor(private http:HttpClient) { 
    this.baseurl = environment.apiUrl;
  }
  public getUnitVersion():Observable<any>{
    return this.http.get<any[]>(this.baseurl + 'B/GetUnitVersion');
  }
  public getInputType():Observable<any>{
    return this.http.get<any[]>(this.baseurl + 'B/GetTypeofUnit');
  }
  
  public getOutputShaft(size:any):Observable<any>{
    const url = `${this.baseurl}B/GetOutputShaft?size=${size}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getMountingPosition(unitversion:string, outputshaft:string):Observable<any>{
    const url = `${this.baseurl}B/GetMountingPosition?unitversion=${unitversion}&outputshaft=${outputshaft}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getMotorAdaptor(size:any,typeOfUnit:any):Observable<any>{
    const url = `${this.baseurl}B/GetMotorAdaptors?size=${size}&typeOfUnit=${typeOfUnit}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getPrimaryMountingPosition(reduction:string,typeofunit:string):Observable<any>{
    const url = `${this.baseurl}B/GetPrimaryMountingPosition?unitversion=${reduction}&outputshaft=${typeofunit}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getFeatures(reduction:any,outputShaft:any, typeOfUnit:any):Observable<any>{
    const url = `${this.baseurl}B/GetFeatures?reduction=${reduction}&outputShaft=${outputShaft}&typeOfUnit=${typeOfUnit}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getSpecification(request:any):Observable<any>{
    debugger;
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'B/GetSpecification',{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  public getLargerReducer(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'B/GetLargerReducer',{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  public getSmallerReducer(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'B/GetSmallerReducer',{
    params:httpParams,
    headers:headers,
    observe:'response',
    responseType:'json'
    });
  }
  public getKits(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'B/GetKits',{
    params:httpParams,
    headers:headers,
    observe:'response',
    responseType:'json'
    });
  }
}
